import React, { useEffect } from "react";

function Header() {
  useEffect(() => {
    const menu = document.getElementById("menu");
    if (menu) {
      menu.classList.add("open");
    }
  }, []);

  return (
    <section id="hero" className="hero headerstart">
      <nav className="navbar navbar-expand-lg fixed-bottom ">
        <div className="container">
          <div className="navbar-collapse " id="navbarNav">
            <ul
              className="navbar-nav d-flex justify-content-center glass"
              id="menu"
            >
              {/* <div className="glow"></div>
              <div className="shine"></div>
              <div className="glow glow-bottom"></div>
              <div className="shine shine-bottom"></div> */}

              <li className="nav-item me-1">
                <a className="nav-link" href="/#hero">
                  Accueil
                </a>
              </li>
              <li className="nav-item me-1">
                <a
                  className="nav-link"
                  target="_blank"
                  href="https://www.linkedin.com/in/aur%C3%A9lien-lepage-584675108/"
                >
                  À propos
                </a>
              </li>
              <li className="nav-item me-1">
                <a className="nav-link" href="/#lesprojets">
                  Projets
                </a>
              </li>
              {/* <li className="nav-item">
                <a className="nav-link" href="#contact">
                  Contact
                </a>
              </li> */}
            </ul>
          </div>
        </div>
      </nav>

      {/* <a className="navbar-brand" href="#hero">
            <img
              src="/img/lepage-studio-logo.svg"
              alt="Logo"
              className="logo"
            />
          </a> */}
      {/* <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button> */}
    </section>
  );
}

export default Header;
